//Include Both Helper File with needed methods
import { getFirebaseBackend } from '../../../helpers/firebase_helper';
import {
	postFakeProfile,
	postJwtProfile,
} from '../../../helpers/fakebackend_helper';

import { getProfile as getProfileApi } from '../../../helpers/auth/backend_helper';

// action
import {
	profileSuccess,
	profileError,
	resetProfileFlagChange,
} from './reducer';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { constants } from '../../../config';

const fireBaseBackend = getFirebaseBackend();

export const editProfile = user => async dispatch => {
	try {
		let response;

		if (constants.REACT_APP_DEFAULTAUTH === 'firebase') {
			response = fireBaseBackend.editProfileAPI(user.username, user.idx);
		} else if (constants.REACT_APP_DEFAULTAUTH === 'jwt') {
			response = postJwtProfile({
				username: user.username,
				idx: user.idx,
			});
		} else if (constants.REACT_APP_DEFAULTAUTH === 'fake') {
			response = postFakeProfile(user);
		}

		const data = await response;

		if (data) {
			dispatch(profileSuccess(data));
		}
	} catch (error) {
		dispatch(profileError(error));
	}
};

export const resetProfileFlag = () => {
	try {
		const response = resetProfileFlagChange();
		return response;
	} catch (error) {
		return error;
	}
};

export const getProfile = createAsyncThunk('profile/getProfile', async () => {
	try {
		const response = getProfileApi();
		return response;
	} catch (error) {
		return error;
	}
});
